import {
  UploadMarketplaceListingIconV2,
  UploadMarketplaceListingIconV2Variables
} from './__generated__/UploadMarketplaceListingIconV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UploadMarketplaceListingIconV2($input: MarketplaceListingIconInputV2!) {
    uploadMarketplaceListingLogoV2(input: $input) {
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
      ... on MarketplaceListingUploadV2 {
        uploadUrl
      }
    }
  }
`

export const useUploadMarketplaceListingIconV2 = () =>
  useMutation<UploadMarketplaceListingIconV2, UploadMarketplaceListingIconV2Variables>(MUTATION)
